import React from 'react'

const CheckBoxFill = props => (
  <svg
    viewBox='0 0 18 18'
    width={props.width || '18px'}
    height={props.height || '18px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill={props.color || '#000'} fillRule='nonzero'>
        <path d='M15,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,15 C0,16.6568542 1.34314575,18 3,18 L15,18 C16.6568542,18 18,16.6568542 18,15 L18,3 C18,1.34314575 16.6568542,0 15,0 Z M13.3,6.61 L8.73,12.61 C8.54120739,12.855247 8.24949665,12.9992561 7.94,13.0000145 C7.63221965,13.001658 7.34082212,12.861492 7.15,12.62 L4.71,9.51 C4.49028166,9.22776018 4.43782669,8.8497415 4.57239438,8.51833993 C4.70696206,8.18693836 5.00810836,7.95250169 5.36239438,7.90333993 C5.7166804,7.85417818 6.07028166,7.99776018 6.29,8.28 L7.92,10.36 L11.7,5.36 C11.917932,5.07418751 12.2717886,4.92635122 12.6282755,4.97217964 C12.9847624,5.01800806 13.2897207,5.25053875 13.4282755,5.58217966 C13.5668304,5.91382056 13.517932,6.29418753 13.3,6.58 L13.3,6.61 Z' />
      </g>
    </g>
  </svg>
)

export default CheckBoxFill
